import _defineProperty from "/home/nftfrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/home/nftfrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/nftfrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/nftfrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/nftfrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * A client library for the https://nft.storage/ service. It provides a convenient
 * interface for working with the [Raw HTTP API](https://nft.storage/#api-docs)
 * from a web browser or [Node.js](https://nodejs.org/) and comes bundled with
 * TS for out-of-the box type inference and better IntelliSense.
 *
 * @example
 * ```js
 * import { NFTStorage, File, Blob } from "nft.storage"
 * const client = new NFTStorage({ token: API_TOKEN })
 *
 * const cid = await client.storeBlob(new Blob(['hello world']))
 * ```
 * @module
 */
import * as API from './lib/interface.js';
import * as Token from './token.js';
import { fetch, File, Blob, FormData } from './platform.js';
/**
 * @implements API.Service
 */

var NFTStorage = /*#__PURE__*/function () {
  /**
   * Constructs a client bound to the given `options.token` and
   * `options.endpoint`.
   *
   * @example
   * ```js
   * import { NFTStorage, File, Blob } from "nft.storage"
   * const client = new NFTStorage({ token: API_TOKEN })
   *
   * const cid = await client.storeBlob(new Blob(['hello world']))
   * ```
   * Optionally you could pass an alternative API endpoint (e.g. for testing)
   * @example
   * ```js
   * import { NFTStorage } from "nft.storage"
   * const client = new NFTStorage({
   *   token: API_TOKEN
   *   endpoint: new URL('http://localhost:8080/')
   * })
   * ```
   *
   * @param {{token: string, endpoint?:URL}} options
   */
  function NFTStorage(_ref) {
    var token = _ref.token,
        _ref$endpoint = _ref.endpoint,
        endpoint = _ref$endpoint === void 0 ? new URL('https://api.nft.storage') : _ref$endpoint;

    _classCallCheck(this, NFTStorage);

    /**
     * Authorization token.
     *
     * @readonly
     */
    this.token = token;
    /**
     * Service API endpoint `URL`.
     * @readonly
     */

    this.endpoint = endpoint;
  }
  /**
   * @hidden
   * @param {string} token
   */


  _createClass(NFTStorage, [{
    key: "storeBlob",
    value: // Just a sugar so you don't have to pass around endpoint and token around.

    /**
     * Stores a single file and returns the corresponding Content Identifier (CID).
     * Takes a [Blob](https://developer.mozilla.org/en-US/docs/Web/API/Blob/Blob)
     * or a [File](https://developer.mozilla.org/en-US/docs/Web/API/File). Note
     * that no file name or file metadata is retained.
     *
     * @example
     * ```js
     * const content = new Blob(['hello world'])
     * const cid = await client.storeBlob(content)
     * cid //> 'Qmf412jQZiuVUtdgnB36FXFX7xg5V6KEbSJ4dpQuhkLyfD'
     * ```
     *
     * @param {Blob} blob
     */
    function storeBlob(blob) {
      return NFTStorage.storeBlob(this, blob);
    }
    /**
     * Stores a directory of files and returns a CID for the directory.
     *
     * @example
     * ```js
     * const cid = await client.storeDirectory([
     *   new File(['hello world'], 'hello.txt'),
     *   new File([JSON.stringify({'from': 'incognito'}, null, 2)], 'metadata.json')
     * ])
     * cid //>
     * ```
     *
     * Argument can be a [FileList](https://developer.mozilla.org/en-US/docs/Web/API/FileList)
     * instance as well, in which case directory structure will be retained.
     *
     * @param {Iterable<File>} files
     */

  }, {
    key: "storeDirectory",
    value: function storeDirectory(files) {
      return NFTStorage.storeDirectory(this, files);
    }
    /**
     * Returns current status of the stored NFT by its CID. Note the NFT must
     * have previously been stored by this account.
     *
     * @example
     * ```js
     * const status = await client.status('Qmf412jQZiuVUtdgnB36FXFX7xg5V6KEbSJ4dpQuhkLyfD')
     * ```
     *
     * @param {string} cid
     */

  }, {
    key: "status",
    value: function status(cid) {
      return NFTStorage.status(this, cid);
    }
    /**
     * Removes stored content by its CID from the service.
     *
     * > Please note that even if content is removed from the service other nodes
     * that have replicated it might still continue providing it.
     *
     * @example
     * ```js
     * await client.delete('Qmf412jQZiuVUtdgnB36FXFX7xg5V6KEbSJ4dpQuhkLyfD')
     * ```
     *
     * @param {string} cid
     */

  }, {
    key: "delete",
    value: function _delete(cid) {
      return NFTStorage.delete(this, cid);
    }
    /**
     * Check if a CID of an NFT is being stored by nft.storage. Throws if the NFT
     * was not found.
     *
     * @example
     * ```js
     * const status = await client.check('Qmf412jQZiuVUtdgnB36FXFX7xg5V6KEbSJ4dpQuhkLyfD')
     * ```
     *
     * @param {string} cid
     */

  }, {
    key: "check",
    value: function check(cid) {
      return NFTStorage.check(this, cid);
    }
    /**
     * Stores the given token and all resources it references (in the form of a
     * File or a Blob) along with a metadata JSON as specificed in
     * [ERC-1155](https://eips.ethereum.org/EIPS/eip-1155#metadata). The
     * `token.image` must be either a `File` or a `Blob` instance, which will be
     * stored and the corresponding content address URL will be saved in the
     * metadata JSON file under `image` field.
     *
     * If `token.properties` contains properties with `File` or `Blob` values,
     * those also get stored and their URLs will be saved in the metadata JSON
     * file in their place.
     *
     * Note: URLs for `File` objects will retain file names e.g. in case of
     * `new File([bytes], 'cat.png', { type: 'image/png' })` will be transformed
     * into a URL that looks like `ipfs://bafy...hash/image/cat.png`. For `Blob`
     * objects, the URL will not have a file name name or mime type, instead it
     * will be transformed into a URL that looks like
     * `ipfs://bafy...hash/image/blob`.
     *
     * @example
     * ```js
     * const metadata = await client.store({
     *   name: 'nft.storage store test',
     *   description: 'Test ERC-1155 compatible metadata.',
     *   image: new File(['<DATA>'], 'pinpie.jpg', { type: 'image/jpg' }),
     *   properties: {
     *     custom: 'Custom data can appear here, files are auto uploaded.',
     *     file: new File(['<DATA>'], 'README.md', { type: 'text/plain' }),
     *   }
     * })
     *
     * console.log('IPFS URL for the metadata:', metadata.url)
     * console.log('metadata.json contents:\n', metadata.data)
     * console.log('metadata.json with IPFS gateway URLs:\n', metadata.embed())
     * ```
     *
     * @template {API.TokenInput} T
     * @param {T} token
     * @returns {Promise<API.Token<T>>}
     */

  }, {
    key: "store",
    value: function store(token) {
      return NFTStorage.store(this, token);
    }
  }], [{
    key: "auth",
    value: function auth(token) {
      if (!token) throw new Error('missing token');
      return {
        Authorization: "Bearer ".concat(token)
      };
    }
    /**
     * @param {API.Service} service
     * @param {Blob} blob
     * @returns {Promise<API.CIDString>}
     */

  }, {
    key: "storeBlob",
    value: function () {
      var _storeBlob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2, blob) {
        var endpoint, token, url, request, result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = _ref2.endpoint, token = _ref2.token;
                url = new URL('/upload', endpoint);

                if (!(blob.size === 0)) {
                  _context.next = 4;
                  break;
                }

                throw new Error('Content size is 0, make sure to provide some content');

              case 4:
                _context.next = 6;
                return fetch(url.toString(), {
                  method: 'POST',
                  headers: NFTStorage.auth(token),
                  body: blob
                });

              case 6:
                request = _context.sent;
                _context.next = 9;
                return request.json();

              case 9:
                result = _context.sent;

                if (!result.ok) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt("return", result.value.cid);

              case 14:
                throw new Error(result.error.message);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function storeBlob(_x, _x2) {
        return _storeBlob.apply(this, arguments);
      }

      return storeBlob;
    }()
    /**
     * @param {API.Service} service
     * @param {Iterable<File>} files
     * @returns {Promise<API.CIDString>}
     */

  }, {
    key: "storeDirectory",
    value: function () {
      var _storeDirectory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3, files) {
        var endpoint, token, url, body, size, _iterator, _step, file, response, result;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                endpoint = _ref3.endpoint, token = _ref3.token;
                url = new URL('/upload', endpoint);
                body = new FormData();
                size = 0;
                _iterator = _createForOfIteratorHelper(files);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    file = _step.value;
                    body.append('file', file, file.name);
                    size += file.size;
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                if (!(size === 0)) {
                  _context2.next = 8;
                  break;
                }

                throw new Error('Total size of files should exceed 0, make sure to provide some content');

              case 8:
                _context2.next = 10;
                return fetch(url.toString(), {
                  method: 'POST',
                  headers: NFTStorage.auth(token),
                  body: body
                });

              case 10:
                response = _context2.sent;
                _context2.next = 13;
                return response.json();

              case 13:
                result = _context2.sent;

                if (!result.ok) {
                  _context2.next = 18;
                  break;
                }

                return _context2.abrupt("return", result.value.cid);

              case 18:
                throw new Error(result.error.message);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function storeDirectory(_x3, _x4) {
        return _storeDirectory.apply(this, arguments);
      }

      return storeDirectory;
    }()
    /**
     * @template {API.TokenInput} T
     * @param {API.Service} service
     * @param {T} metadata
     * @returns {Promise<API.Token<T>>}
     */

  }, {
    key: "store",
    value: function () {
      var _store = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4, metadata) {
        var endpoint, token, url, body, paths, response, result, value;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                endpoint = _ref4.endpoint, token = _ref4.token;
                validateERC1155(metadata);
                url = new URL("/store", endpoint);
                body = Token.encode(metadata);
                paths = new Set(body.keys());
                _context3.next = 7;
                return fetch(url.toString(), {
                  method: 'POST',
                  headers: NFTStorage.auth(token),
                  body: body
                });

              case 7:
                response = _context3.sent;
                _context3.next = 10;
                return response.json();

              case 10:
                result = _context3.sent;

                if (!(result.ok === true)) {
                  _context3.next = 16;
                  break;
                }

                value = result.value;
                return _context3.abrupt("return", Token.decode(value, paths));

              case 16:
                throw new Error(result.error.message);

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function store(_x5, _x6) {
        return _store.apply(this, arguments);
      }

      return store;
    }()
    /**
     * @param {API.Service} service
     * @param {string} cid
     * @returns {Promise<API.StatusResult>}
     */

  }, {
    key: "status",
    value: function () {
      var _status = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref5, cid) {
        var endpoint, token, url, response, result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                endpoint = _ref5.endpoint, token = _ref5.token;
                url = new URL("/".concat(cid), endpoint);
                _context4.next = 4;
                return fetch(url.toString(), {
                  method: 'GET',
                  headers: NFTStorage.auth(token)
                });

              case 4:
                response = _context4.sent;
                _context4.next = 7;
                return response.json();

              case 7:
                result = _context4.sent;

                if (!result.ok) {
                  _context4.next = 12;
                  break;
                }

                return _context4.abrupt("return", {
                  cid: result.value.cid,
                  deals: decodeDeals(result.value.deals),
                  size: result.value.size,
                  pin: decodePin(result.value.pin),
                  created: new Date(result.value.created)
                });

              case 12:
                throw new Error(result.error.message);

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function status(_x7, _x8) {
        return _status.apply(this, arguments);
      }

      return status;
    }()
    /**
     * @param {API.PublicService} service
     * @param {string} cid
     * @returns {Promise<API.CheckResult>}
     */

  }, {
    key: "check",
    value: function () {
      var _check = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref6, cid) {
        var endpoint, url, response, result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                endpoint = _ref6.endpoint;
                url = new URL("/check/".concat(cid), endpoint);
                _context5.next = 4;
                return fetch(url.toString());

              case 4:
                response = _context5.sent;
                _context5.next = 7;
                return response.json();

              case 7:
                result = _context5.sent;

                if (!result.ok) {
                  _context5.next = 12;
                  break;
                }

                return _context5.abrupt("return", {
                  cid: result.value.cid,
                  deals: decodeDeals(result.value.deals),
                  pin: result.value.pin
                });

              case 12:
                throw new Error(result.error.message);

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function check(_x9, _x10) {
        return _check.apply(this, arguments);
      }

      return check;
    }()
    /**
     * @param {API.Service} service
     * @param {string} cid
     * @returns {Promise<void>}
     */

  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref7, cid) {
        var endpoint, token, url, response, result;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                endpoint = _ref7.endpoint, token = _ref7.token;
                url = new URL("/".concat(cid), endpoint);
                _context6.next = 4;
                return fetch(url.toString(), {
                  method: 'DELETE',
                  headers: NFTStorage.auth(token)
                });

              case 4:
                response = _context6.sent;
                _context6.next = 7;
                return response.json();

              case 7:
                result = _context6.sent;

                if (result.ok) {
                  _context6.next = 10;
                  break;
                }

                throw new Error(result.error.message);

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function _delete(_x11, _x12) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return NFTStorage;
}();
/**
 * @param {API.TokenInput} metadata
 */


var validateERC1155 = function validateERC1155(_ref8) {
  var name = _ref8.name,
      description = _ref8.description,
      image = _ref8.image,
      decimals = _ref8.decimals;

  // Just validate that expected fields are present
  if (typeof name !== 'string') {
    throw new TypeError('string property `name` identifying the asset is required');
  }

  if (typeof description !== 'string') {
    throw new TypeError('string property `description` describing asset is required');
  }

  if (!(image instanceof Blob) || !image.type.startsWith('image/')) {
    throw new TypeError('proprety `image` must be a Blob or File object with `image/*` mime type');
  }

  if (typeof decimals !== 'undefined' && typeof decimals !== 'number') {
    throw new TypeError('proprety `decimals` must be an integer value');
  }
};
/**
 * @param {API.Deal[]} deals
 * @returns {API.Deal[]}
 */


var decodeDeals = function decodeDeals(deals) {
  return deals.map(function (deal) {
    var _dealExpiration$dealA = _objectSpread({
      dealExpiration: null,
      dealActivation: null
    }, deal),
        dealActivation = _dealExpiration$dealA.dealActivation,
        dealExpiration = _dealExpiration$dealA.dealExpiration,
        lastChanged = _dealExpiration$dealA.lastChanged;

    return _objectSpread(_objectSpread(_objectSpread({}, deal), {}, {
      lastChanged: new Date(lastChanged)
    }, dealActivation && {
      dealActivation: new Date(dealActivation)
    }), dealExpiration && {
      dealExpiration: new Date(dealExpiration)
    });
  });
};
/**
 * @param {API.Pin} pin
 * @returns {API.Pin}
 */


var decodePin = function decodePin(pin) {
  return _objectSpread(_objectSpread({}, pin), {}, {
    created: new Date(pin.created)
  });
};

var TokenModel = Token.Token;
export { TokenModel as Token };
export { NFTStorage, File, Blob, FormData };
/**
 * Just to verify API compatibility.
 * @type {API.API}
 */

var api = NFTStorage;
void api;